import { Box } from "@mui/material";
import { useGetReleaseTrackFileVersionURL } from "../../../../api/files/hooks/useGetReleaseTrackFileVersionURL";
import { usePlayPauseOnFooter } from "../../../../hooks/audioPlayerHooks/useGetFooterPlayerRef";
import {
  FooterFileTrackType,
  setLocalPlayer,
} from "../../../../store/actions/abPlayerStore";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { PlaylistTrack } from "../../../../store/models/playListTrack/types";
import { getCurrentTrackFromPlaylist } from "../../../../store/selectors/abPlayerSelectors";
import {
  PlaybackControlButton,
  PlaybackControlButtonVariant,
} from "../../../elements/PlaybackControlButton/PlaybackControlButton";
import { FeaturedTrackPlayer } from "../../FeaturedTrackPlayer/FeaturedTrackPlayer";
import { CenteredSoundWaveLoader } from "../../CenteredSoundWaveLoader/CenteredSoundWaveLoader";
import { TextStyleVariant } from "../../../core-ui/components/Text/TextUtils";
import { Text } from "../../../core-ui/components/Text/Text";
import { UploadReleaseTrackPlayerContainer } from "./UploadReleaseTrack.styles";
interface ReleaseTackPlayerProps {
  uploadedTrack: PlaylistTrack | null;
  releaseId: number;
  fileName?: string;
}

export const UploadReleaseTrackPlayer = ({
  uploadedTrack,
  releaseId,
  fileName,
}: ReleaseTackPlayerProps) => {
  const { handleClick: handlePlayPause } = usePlayPauseOnFooter();
  const dispatch = useAppDispatch();
  const currentTrack = useAppSelector(getCurrentTrackFromPlaylist());
  const { isFooterPlaying } = useAppSelector((state) => state.abPlayerStore);

  const { data: getReleaseTrackUrl, isLoading } =
    useGetReleaseTrackFileVersionURL(uploadedTrack?.fileVersionId);
  const isCurrentTrackPlaying = Boolean(
    currentTrack && currentTrack.id === uploadedTrack?.id,
  );

  const handleOnClick = () => {
    if (currentTrack && uploadedTrack?.id === currentTrack.id) {
      handlePlayPause();
      return;
    }
    if (!uploadedTrack) {
      return;
    }
    dispatch(
      setLocalPlayer({
        url: getReleaseTrackUrl?.url,
        trackedPlayerId: uploadedTrack.id,
        keepPosition: false,
        playOnLoad: true,
        footerFileTrackType: FooterFileTrackType.RELEASE,
        loadedTrack: uploadedTrack,
      }),
    );
  };
  return (
    <UploadReleaseTrackPlayerContainer>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          alignSelf: "stretch",
          justifyContent: "space-between",
        }}
      >
        <Text variant={TextStyleVariant.H6}>Playback</Text>
      </Box>
      {isLoading && !getReleaseTrackUrl && <CenteredSoundWaveLoader />}
      {getReleaseTrackUrl?.url && (
        <FeaturedTrackPlayer
          id={releaseId}
          source={getReleaseTrackUrl.url}
          isSameProject={isCurrentTrackPlaying}
          showTime
          isPlayingOnFooter={isFooterPlaying}
          fileName={fileName}
        />
      )}
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <PlaybackControlButton
          variant={
            isFooterPlaying && isCurrentTrackPlaying
              ? PlaybackControlButtonVariant.PAUSE
              : PlaybackControlButtonVariant.PLAY_CIRCLE
          }
          style={{ height: "28px", width: "28px" }}
          disabled={getReleaseTrackUrl?.url === undefined}
          isPrimary
          onClick={handleOnClick}
        />
      </Box>
    </UploadReleaseTrackPlayerContainer>
  );
};
